import StandaloneSurveyPageLayout from "components/v3/layouts/StandaloneSurveyPageLayout";
import CologuardQualificationSurvey from "components/v3/sharedComponents/surveys/CologuardQualificationSurvey";
import { PATHS } from "constants/pathConstants";

const CologuardQualificationSurveyPage = (): React.ReactElement => {
  return (
    <StandaloneSurveyPageLayout
      exitTo={PATHS.YOUR_NEXT_STEPS}
      pageTitle="Colon cancer screening"
      showLogoHeader
    >
      <CologuardQualificationSurvey />
    </StandaloneSurveyPageLayout>
  );
};

export default CologuardQualificationSurveyPage;
